(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["icon-text-card"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    if (window.__iconTextCardPopupInitialized) return;
    window.__iconTextCardPopupInitialized = true;

    document.body.addEventListener('click', function (event) {
      const trigger = event.target.closest(
        '.icon-text-card [data-link-popup] a',
      );
      if (!trigger) return;

      const popupId = trigger.hash.replace(/^#/, '');
      const card = trigger.closest('.icon-text-card');
      const title = card?.querySelector('.nw-h3')?.textContent.trim() || '';
      const buttonName = trigger.textContent.trim();

      window.dataLayer.push({ event_parameters: null });
      window.dataLayer.push({
        event: 'ga4Event',
        event_name: 'icon-text-card-click',
        event_parameters: {
          current_page: window.location.href,
          title: title,
          button_name: buttonName,
          link: popupId || trigger.href,
        },
      });

      if (!popupId) return;

      const popup = document.querySelector('.subscribe-popup-' + popupId);
      const popupGroup = document.querySelector('#PopupModal-' + popupId);

      if (popupGroup) {
        return popupGroup.show();
      }

      if (popup) {
        event.preventDefault();
        popup.classList.remove('hidden');
        popup.classList.add('flex');
        document.body.classList.add('no-scroll');
      }
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["navimow-banner-countdown"] && !Shopify.designMode) return;
  try {
    (() => {
    if (!window.__navimowBannerCountdownInit) {
      window.__navimowBannerCountdownInit = (root = document) => {
        if (!root || typeof root.querySelectorAll !== 'function') {
          root = document;
        }

        root
          .querySelectorAll('[data-banner-countdown]')
          .forEach((countdown) => {
            if (countdown.dataset.bannerCountdownBound === 'true') return;

            countdown.dataset.bannerCountdownBound = 'true';
            let remainingSeconds = Number(
              countdown.dataset.remainingSeconds || 0,
            );
            const unitElements = {
              days: countdown.querySelector('[data-countdown-days]'),
              hours: countdown.querySelector('[data-countdown-hours]'),
              minutes: countdown.querySelector('[data-countdown-minutes]'),
              seconds: countdown.querySelector('[data-countdown-seconds]'),
            };
            const format = (value) =>
              String(Math.max(0, value)).padStart(2, '0');

            const render = () => {
              if (remainingSeconds <= 0) {
                countdown.hidden = true;
                window.clearInterval(countdown.bannerCountdownInterval);
                return false;
              }

              const days = Math.floor(remainingSeconds / 86400);
              const dayRemainder = remainingSeconds % 86400;
              const hours = Math.floor(dayRemainder / 3600);
              const hourRemainder = dayRemainder % 3600;
              const minutes = Math.floor(hourRemainder / 60);
              const seconds = hourRemainder % 60;

              if (unitElements.days)
                unitElements.days.textContent = format(days);
              if (unitElements.hours)
                unitElements.hours.textContent = format(hours);
              if (unitElements.minutes)
                unitElements.minutes.textContent = format(minutes);
              if (unitElements.seconds)
                unitElements.seconds.textContent = format(seconds);
              countdown.setAttribute(
                'aria-label',
                `${days} ${countdown.dataset.labelDays}, ${hours} ${countdown.dataset.labelHours}, ${minutes} ${countdown.dataset.labelMinutes}, ${seconds} ${countdown.dataset.labelSeconds}`,
              );
              return true;
            };

            if (!render()) return;

            countdown.bannerCountdownInterval = window.setInterval(() => {
              remainingSeconds -= 1;
              render();
            }, 1000);
          });
      };
    }

    if (!window.__navimowBannerCountdownEventsBound) {
      window.__navimowBannerCountdownEventsBound = true;
      const init = () => window.__navimowBannerCountdownInit(document);

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init, { once: true });
      } else {
        init();
      }

      document.addEventListener('shopify:section:load', (event) => {
        window.__navimowBannerCountdownInit(event.target);
      });

      document.addEventListener('shopify:section:unload', (event) => {
        if (!event.target || typeof event.target.querySelectorAll !== 'function') return;

        event.target
          .querySelectorAll('[data-banner-countdown]')
          .forEach((countdown) => {
            window.clearInterval(countdown.bannerCountdownInterval);
          });
      });
    } else {
      window.__navimowBannerCountdownInit(document);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-bundle-sale"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    const bundleSaleContainer = document.querySelector('.product-bundle-sale');
    if (!bundleSaleContainer) return;

    const descriptions = bundleSaleContainer.querySelectorAll(
      '.bundle-sale-item-description',
    );

    descriptions.forEach((desc) => {
      const inner = desc.querySelector('.bundle-sale-item-description-inner');
      if (inner) {
        desc.style.setProperty('--max-height', inner.clientHeight + 'px');
      }
    });

    const radioInputs = bundleSaleContainer.querySelectorAll(
      'input[type="radio"]',
    );
    radioInputs.forEach((radio) => {
      radio.addEventListener('click', function () {
        if (radio.dataset.checked === undefined) {
          radio.dataset.checked = radio.checked;
        } else {
          radio.checked = radio.dataset.checked === 'true' ? false : true;
          radio.dataset.checked = radio.checked;
        }

        if (radio.checked) {
          radioInputs.forEach((item) => {
            if (radio !== item) item.dataset.checked = false;
          });
        }
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-discount-card"] && !Shopify.designMode) return;
  try {
    (() => {
      if (!window.__navimowProductDiscountCardInit) {
        window.__navimowProductDiscountCardInit = function(root) {
          if(!root) return;
          const scope = root || document;
          const params = new URLSearchParams(window.location.search);
          const getStoredUtmValue = (key) => {
            const urlValue = params.get(key);
            if (urlValue !== null) return urlValue;

            try {
              return window.sessionStorage.getItem(key);
            } catch (error) {
              return null;
            }
          };

          scope.querySelectorAll('[data-discount-card][data-utm-filtered="true"]').forEach((card) => {
            const displayMode = card.dataset.utmDisplayMode || 'whitelist';
            const rules = [
              ['utm_source', card.dataset.utmSource],
              ['utm_medium', card.dataset.utmMedium],
              ['utm_campaign', card.dataset.utmCampaign],
            ].filter((rule) => rule[1]);

            const matched = rules.some(([key, expected]) => {
              const current = getStoredUtmValue(key);
              if (current === null) return false;

              return expected
                .split(',')
                .map((value) => value.trim())
                .filter(Boolean)
                .some((value) => current === value);
            });

            card.classList.toggle('hidden', displayMode === 'blacklist' ? matched : !matched);
          });

          scope.querySelectorAll('[data-discount-countdown]').forEach((countdown) => {
            if (countdown.dataset.discountCountdownBound === 'true') return;
            countdown.dataset.discountCountdownBound = 'true';

            const card = countdown.closest('[data-discount-card]');
            let remainingSeconds = Number(countdown.dataset.remainingSeconds || 0);
            const unitEls = {
              days: countdown.querySelector('[data-countdown-days]'),
              hours: countdown.querySelector('[data-countdown-hours]'),
              minutes: countdown.querySelector('[data-countdown-minutes]'),
              seconds: countdown.querySelector('[data-countdown-seconds]'),
            };
            const format = (value) => String(Math.max(0, value)).padStart(2, '0');
            const render = () => {
              if (remainingSeconds <= 0) {
                if (card) card.style.display = 'none';
                return false;
              }

              const days = Math.floor(remainingSeconds / 86400);
              const dayRemainder = remainingSeconds % 86400;
              const hours = Math.floor(dayRemainder / 3600);
              const hourRemainder = dayRemainder % 3600;
              const minutes = Math.floor(hourRemainder / 60);
              const seconds = hourRemainder % 60;

              if (unitEls.days) unitEls.days.textContent = format(days);
              if (unitEls.hours) unitEls.hours.textContent = format(hours);
              if (unitEls.minutes) unitEls.minutes.textContent = format(minutes);
              if (unitEls.seconds) unitEls.seconds.textContent = format(seconds);
              return true;
            };

            if (!render()) return;

            window.setInterval(() => {
              remainingSeconds -= 1;
              render();
            }, 1000);
          });

          scope.querySelectorAll('[data-discount-card] button[is="copy-button"][aria-controls]').forEach((button) => {
            if (button.dataset.discountPopoverBound === 'true') return;
            button.dataset.discountPopoverBound = 'true';

            button.addEventListener('click', () => {
              const popover = document.getElementById(button.getAttribute('aria-controls'));
              if (!popover) return;

              window.clearTimeout(button.discountPopoverTimer);
              button.discountPopoverTimer = window.setTimeout(() => {
                popover.hidden = true;
              }, 2200);
            });
          });
        };
      }

      const init = () => window.__navimowProductDiscountCardInit(document);

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init, { once: true });
      } else {
        init();
      }

      document.addEventListener('shopify:section:load', (event) => {
        window.__navimowProductDiscountCardInit(event.target);
      });
    })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-recommendation"] && !Shopify.designMode) return;
  try {
    (() => {
    if (!window.__navimowProductRecommendationInit) {
      window.__navimowProductRecommendationInit = function (root) {
        const scope = root || document;
        const params = new URLSearchParams(window.location.search);
        const splitRules = (value) =>
          String(value || '')
            .split(/[\n,]+/)
            .map((item) => item.trim())
            .filter(Boolean);
        const getStoredUtmValue = (key) => {
          const urlValue = params.get(key);
          if (urlValue !== null) return urlValue;

          try {
            return window.sessionStorage.getItem(key);
          } catch (error) {
            return null;
          }
        };
        const syncCard = (card) => {
          const input = card.querySelector(
            '[data-product-recommendation-input]',
          );
          const visibleByVariant = card.dataset.visibleByVariant !== 'false';
          const visibleByUtm = card.dataset.visibleByUtm !== 'false';
          const visible = visibleByVariant && visibleByUtm;

          card.classList.toggle('hidden', !visible);

          if (input) {
            const baseDisabled = input.dataset.baseDisabled === 'true';
            input.disabled = baseDisabled || !visible;
          }
        };
        const syncTitleVisibility = (productInfo) => {
          if (!productInfo) return;

          const cards = Array.from(
            productInfo.querySelectorAll('[data-product-recommendation]'),
          );
          const title = cards[0]?.previousElementSibling;

          if (!title?.classList.contains('product-info-text')) return;

          const allCardsHidden = cards.every((card) =>
            card.classList.contains('hidden'),
          );

          if (allCardsHidden) {
            if (!title.classList.contains('hidden')) {
              title.classList.add('hidden');
              title.dataset.hiddenByProductRecommendation = 'true';
            }
          } else if (title.dataset.hiddenByProductRecommendation === 'true') {
            title.classList.remove('hidden');
            delete title.dataset.hiddenByProductRecommendation;
          }
        };
        const applyUtmRules = (card) => {
          if (card.dataset.utmFiltered !== 'true') {
            card.dataset.visibleByUtm = 'true';
            return;
          }

          const displayMode = card.dataset.utmDisplayMode || 'whitelist';
          const rules = [
            ['utm_source', card.dataset.utmSource],
            ['utm_medium', card.dataset.utmMedium],
            ['utm_campaign', card.dataset.utmCampaign],
          ].filter((rule) => rule[1]);

          const matched = rules.some(([key, expected]) => {
            const current = getStoredUtmValue(key);
            if (current === null) return false;

            return splitRules(expected).some((value) => current === value);
          });

          card.dataset.visibleByUtm =
            displayMode === 'blacklist' ? String(!matched) : String(matched);
        };
        const applyVariantRules = (card, variantId) => {
          const rules = splitRules(card.dataset.applyForVariants);
          card.dataset.visibleByVariant = String(
            !rules.length || (variantId && rules.includes(String(variantId))),
          );
        };
        const updateCardsForForm = (formId, variantId) => {
          if (!formId) return;

          document.querySelectorAll('product-info').forEach((productInfo) => {
            let hasMatchingCard = false;

            productInfo
              .querySelectorAll('[data-product-recommendation]')
              .forEach((card) => {
                if (card.dataset.productFormId !== formId) return;

                hasMatchingCard = true;
                applyVariantRules(card, variantId);
                applyUtmRules(card);
                syncCard(card);
              });

            if (hasMatchingCard) syncTitleVisibility(productInfo);
          });
        };

        const productInfos = new Set();
        scope
          .querySelectorAll('[data-product-recommendation]')
          .forEach((card) => {
            const input = card.querySelector(
              '[data-product-recommendation-input]',
            );
            if (
              input &&
              input.dataset.mustCheck === 'true' &&
              input.dataset.recommendationMustCheckBound !== 'true'
            ) {
              input.dataset.recommendationMustCheckBound = 'true';
              input.checked = true;
              input.addEventListener('click', (event) => {
                event.preventDefault();
                input.checked = true;
              });
            }

            applyUtmRules(card);
            syncCard(card);

            const productInfo = card.closest('product-info');
            if (productInfo) productInfos.add(productInfo);
          });
        productInfos.forEach(syncTitleVisibility);

        const forms = new Set();
        scope
          .querySelectorAll('[data-product-recommendation-input][form]')
          .forEach((input) => {
            const form = document.getElementById(input.getAttribute('form'));
            if (form) forms.add(form);
          });

        forms.forEach((form) => {
          const currentVariantId = form.querySelector('[name="id"]')?.value;
          updateCardsForForm(form.id, currentVariantId);

          if (form.dataset.productRecommendationVariantBound === 'true') return;
          form.dataset.productRecommendationVariantBound = 'true';

          document.addEventListener('variant:change', (event) => {
            const variantId =
              event.detail && event.detail.variant && event.detail.variant.id;
            updateCardsForForm(form.id, variantId);
          });
        });

        if (
          window.theme?.pubsub?.subscribe &&
          window.theme?.pubsub?.PUB_SUB_EVENTS?.variantChange &&
          window.__navimowProductRecommendationPubsubBound !== true
        ) {
          window.__navimowProductRecommendationPubsubBound = true;
          theme.pubsub.subscribe(
            theme.pubsub.PUB_SUB_EVENTS.variantChange,
            (event) => {
              const data = event && event.data;
              const variantId = data?.variant?.id;
              const formId =
                data?.sectionId && data?.productId
                  ? `ProductForm-${data.sectionId}-${data.productId}`
                  : null;

              updateCardsForForm(formId, variantId);
            },
          );
        }
      };
    }

    const init = () => window.__navimowProductRecommendationInit(document);

    document.addEventListener('DOMContentLoaded', init, { once: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
